import { Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";

import Loader from "../../../components/Loader";
import { GenericObject } from "../../../types/generic.types";
import { clientDocRef } from "../../../utils/referencies";

const ClientPhone: FC<{ id: string }> = ({ id }) => {
  const [clientLoading, setClientLoading] = useState(true);
  const [client, setClient] = useState<GenericObject | undefined>(undefined);

  const fetchVendor = async () => {
    setClientLoading(true);
    try {
      const snapshot = await clientDocRef(id).get();
      if (snapshot.exists) {
        setClientLoading(false);
        setClient(snapshot.data());
      }
    } catch (ex: any) {
      setClientLoading(false);
      console.log(ex.message);
    }
  };

  useEffect(() => {
    fetchVendor();
  }, []);

  return (
    <Typography variant="body2" style={{ width: 110 }} color="textSecondary">
      <Loader loading={clientLoading}>{client && <>{client.phoneNumber}</>}</Loader>
    </Typography>
  );
};

export default ClientPhone;
